/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dato[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{display:block;font-size:12px;font-weight:800;margin-bottom:0}.dato[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{display:block;background:rgba(175,175,175,.1);border-radius:4px;height:26px;width:100%;font-weight:400;padding:2px 5px}.dato[_ngcontent-%COMP%]   .value2[_ngcontent-%COMP%]{background:#dee2e6;border-radius:5px;padding:10px 20px}.dato[_ngcontent-%COMP%]   .monto[_ngcontent-%COMP%]{font-weight:800;background:#dee2e6;padding:10px;border-radius:5px;margin-bottom:5px}"];
export { styles as styles };
